import { render, staticRenderFns } from "./ManagementSystemReports.vue?vue&type=template&id=5d8386ce&scoped=true&"
import script from "./ManagementSystemReports.vue?vue&type=script&lang=js&"
export * from "./ManagementSystemReports.vue?vue&type=script&lang=js&"
import style0 from "./ManagementSystemReports.vue?vue&type=style&index=0&id=5d8386ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8386ce",
  null
  
)

export default component.exports